// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {Point} from './point.js'

export class FractionalAttachedEndpoint {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): FractionalAttachedEndpoint {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  entity(obj?: Id): Id | null {
    return (obj || new Id()).__init(this.bb_pos, this.bb!)
  }

  fraction(obj?: Point): Point | null {
    return (obj || new Point()).__init(this.bb_pos + 8, this.bb!)
  }

  static sizeOf(): number {
    return 16
  }

  static createFractionalAttachedEndpoint(
    builder: flatbuffers.Builder,
    entity_site: number,
    entity_timestamp: number,
    fraction_x: number,
    fraction_y: number
  ): flatbuffers.Offset {
    builder.prep(4, 16)
    builder.prep(4, 8)
    builder.writeFloat32(fraction_y)
    builder.writeFloat32(fraction_x)
    builder.prep(4, 8)
    builder.writeInt32(entity_timestamp)
    builder.pad(2)
    builder.writeInt16(entity_site)
    return builder.offset()
  }
}
